import { Model } from 'app/model/backendmodel';
import { CommonDataServiceCopySource } from './../../../pipeline/copysource/common-data-service.copysource';
import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(CommonDataServiceCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class CommonDataServiceCopySourceAdapter extends CopySourceAdapter<
    CommonDataServiceCopySource,
    Model.CommonDataServiceSource
> {
    protected override async _toResource(
        copySource: CommonDataServiceCopySource
    ): Promise<Model.CommonDataServiceSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(CommonDataServiceCopySource).name);
    }

    protected override async _toModel(
        resource: Model.CommonDataServiceSource,
        copyActivity: CopyActivity
    ): Promise<CommonDataServiceCopySource> {
        return this._toTabularModel(resource, copyActivity, CommonDataServiceCopySource.MODEL);
    }
}
